import { Button, Modal } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

import classes from './elements.module.css';

const styles = {
  dialog: {
    bodyStyle: {
      borderTop: 'initial',
      borderBottom: 'initial',
    },
    title: {
      fontSize: fonts.xl,
      padding: '1.125em 1.125em 1.125em 1.25em',
      fontWeight: '500',
    },
    actionsContainerStyle: {
      margin: 0,
      padding: 0,
    },
  },
  actionButtons: {
    cancel: { margin: '0.25rem' },
  },
  floatingLabelStyle: {
    color: colors.neutral.dim,
  },
  textFieldStyle: {
    color: colors.neutral.dark,
  },
};

interface Props {
  title: string;
  assetName: string;
  open: boolean;
  closeModal: () => any;
}

const FhwaNoElementsDialog = ({
  title,
  assetName,
  open,
  closeModal,
}: Props) => {
  const getFooter = () => {
    return (
      <div style={styles.dialog.actionsContainerStyle}>
        <Button sx={styles.actionButtons.cancel} onClick={closeModal}>
          OK
        </Button>
      </div>
    );
  };

  const dialogContent = (
    <div className={classes.elementModalSubheading}>
      There are no elements under
      <span className={classes.elementModalAssetName}> {assetName}</span>
    </div>
  );

  return (
    <div>
      <Modal
        title={title}
        footer={getFooter()}
        style={styles.dialog.bodyStyle}
        open={open}
      >
        {dialogContent}
      </Modal>
    </div>
  );
};

export default FhwaNoElementsDialog;
